/* This is generated code, don't alter */
var IfcAnalysisTheoryTypeEnum;
(function (IfcAnalysisTheoryTypeEnum) {
    IfcAnalysisTheoryTypeEnum[IfcAnalysisTheoryTypeEnum["FIRST_ORDER_THEORY"] = 0] = "FIRST_ORDER_THEORY";
    IfcAnalysisTheoryTypeEnum[IfcAnalysisTheoryTypeEnum["SECOND_ORDER_THEORY"] = 1] = "SECOND_ORDER_THEORY";
    IfcAnalysisTheoryTypeEnum[IfcAnalysisTheoryTypeEnum["THIRD_ORDER_THEORY"] = 2] = "THIRD_ORDER_THEORY";
    IfcAnalysisTheoryTypeEnum[IfcAnalysisTheoryTypeEnum["FULL_NONLINEAR_THEORY"] = 3] = "FULL_NONLINEAR_THEORY";
    IfcAnalysisTheoryTypeEnum[IfcAnalysisTheoryTypeEnum["USERDEFINED"] = 4] = "USERDEFINED";
    IfcAnalysisTheoryTypeEnum[IfcAnalysisTheoryTypeEnum["NOTDEFINED"] = 5] = "NOTDEFINED";
})(IfcAnalysisTheoryTypeEnum || (IfcAnalysisTheoryTypeEnum = {}));
const IfcAnalysisTheoryTypeEnumCount = 6;
export { IfcAnalysisTheoryTypeEnum, IfcAnalysisTheoryTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcAnalysisTheoryTypeEnum = new Int32Array([230]);
let prefixSumAddressIfcAnalysisTheoryTypeEnum = new Uint32Array([0, 23, 44, 56, 76, 96, 109]);
let slotMapIfcAnalysisTheoryTypeEnum = new Int32Array([3, 1, 5, 0, 2, 4]);
let encodedDataIfcAnalysisTheoryTypeEnum = (new TextEncoder()).encode(".FULL_NONLINEAR_THEORY..SECOND_ORDER_THEORY..NOTDEFINED..FIRST_ORDER_THEORY..THIRD_ORDER_THEORY..USERDEFINED.");
let IfcAnalysisTheoryTypeEnumSearch = new MinimalPerfectHash(gMapIfcAnalysisTheoryTypeEnum, prefixSumAddressIfcAnalysisTheoryTypeEnum, slotMapIfcAnalysisTheoryTypeEnum, encodedDataIfcAnalysisTheoryTypeEnum);
export { IfcAnalysisTheoryTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcAnalysisTheoryTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcAnalysisTheoryTypeEnumSearch, input, cursor, endCursor);
}
